import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { environment as env } from 'src/environments/environment' //ALTERAR VARIÁVEIS PARA PARCEIRO ITAÚ
import { Observable, of } from 'rxjs'

export type Option = {
	icon: string
	name: string
	slug: string
	preview?: boolean
	sendEmail?: boolean
}

export type Sector = {
	title: string
	options: Option[]
}
@Injectable({ providedIn: 'root' })
export class ReportsEsferaService {
	public sectors: Sector[] = [
		{
			title: 'Financeiro',
			options: [
				{
					icon: 'tagmeicon tagmeicon-voucher-mini',
					name: 'Amenidades',
					slug: 'financial-amenities',
				},
			],
		},
	]

	public options = this.sectors.flatMap(sector => sector.options)

	constructor(private http: HttpClient) { }

	chooseReportToCall(
		slug: string,
		query: {
			startDate: string
			endDate: string
			partnerId?: string
			filterDate?: string
			venue?: string
		},
		format: 'csv' | 'json' = 'csv'
	): Observable<any> {
		const responseType = (format === 'csv' ? 'blob' : 'json') as any
		switch (slug) {
			case 'financial-amenities':
				return this.http.get(
					`${env.channelsAPI.baseURL}reports/esfera/financialAmenities?startDate=${query.startDate}&endDate=${query.endDate}&format=${format}`,
					{ responseType }
				)
			default:
				console.warn('Nenhum slug encontrado')
				return of([])
		}
	}
}
